import { render, staticRenderFns } from "./TitleBox.html?vue&type=template&id=6b7df327&scoped=true&"
import script from "./TitleBox.js?vue&type=script&lang=js&"
export * from "./TitleBox.js?vue&type=script&lang=js&"
import style0 from "./TitleBox.scss?vue&type=style&index=0&id=6b7df327&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7df327",
  null
  
)

export default component.exports